/*
 * MSAL configuration for authentication
 * This module exports configuration that will be loaded at runtime
 */

import { getMsalConfig, getApiConfig } from '../utils/configLoader';

// Export a getter function instead of a static object
// This ensures the config is loaded from runtime configuration
export const getMsalConfigFromRuntime = () => {
    return getMsalConfig();
};

// Legacy export for backward compatibility
// This will throw an error if config hasn't been loaded yet
export const msalConfig = new Proxy({}, {
    get: (target, prop) => {
        const config = getMsalConfig();
        return config[prop];
    }
});

// Add scopes here for access token request
// For more information about scopes visit: 
// https://learn.microsoft.com/en-us/azure/active-directory/develop/permissions-consent-overview
export const loginRequest = {
    scopes: ["User.Read"]
};

// Add endpoints here for API calls
// These are now loaded from runtime configuration

export const getApiConfigFromRuntime = () => {
    return getApiConfig();
};

// Legacy export for backward compatibility
export const apiConfig = new Proxy({}, {
    get: (target, prop) => {
        const config = getApiConfig();
        return config[prop];
    }
});